<template>
	<!-- <v-card dark flat tile full-width fill-height class="card-center justify-center">

		<v-card-text>
			<BrandLogoLoader :gutter="10" :interval-time="100" color="primary" indeterminate inverted />
			<h1 class="mt-10 mb-2">Partners Dashboard</h1>
			<h4 class="opacity-high">Make Yourself Woth!</h4>
		</v-card-text>


		<v-card-text v-if="!error">
			<h6 v-if="authenticated && user" class="text-capitalize mb-1 opacity">{{ user.name }}, we're loading your
			</h6>
			<h2 v-if="partner">{{ partner.name }} Dashboard</h2>
		</v-card-text>

		<v-card-text v-else>
			<v-btn x-large class="px-10 mb-1" to="/" style="min-width:320px">
				Go to Home
				<v-icon right dark>$vuetify.icons.dashboard</v-icon>
			</v-btn>
			<v-btn x-large class="px-10 mb-5" @click="login" style="min-width:320px">
				Log-in again
				<v-icon right dark>$vuetify.icons.user</v-icon>
			</v-btn>

			<v-alert type="error" prominent outlined :value="true" v-if="error" style="min-width:320px">{{error}}</v-alert>
		</v-card-text>

	</v-card> -->

	<v-sheet color="primary darken-2" fill-height>
		<v-container fill-height>
			<v-row align="center" justify="center">
				<v-col lg="4" xl="3">
					<v-card class="card-center" fill-height color="black" dark outlined elevation="8"
						style="min-height:40vh">
						<v-card-text class="pos-r">
							<div class="ripple accent-color circle pos-a" v-show="!error"></div>
							<BrandLogoLoader dark :width="4" :gutter="8" :infinite="loading" color="primary" />
						</v-card-text>
						<v-spacer />
						<v-card-text class="py-0">
							<h2>Ownli&trade; Partners</h2>
						</v-card-text>
						<v-card-text class="shrink pt-0" v-if="error && !loading">
							<h2>{{error}}</h2>

							<v-btn large color="primary" class="mt-5" @click="forcedLogin" :disabled="loading">
								Try again <v-icon right>$vuetify.icons.login</v-icon>
							</v-btn>
						</v-card-text>
						<v-card-text class="shrink pt-0" v-else>
							<CountDownTimer :time="3000" color="primary" :interval="100" height="52" rounded />
							<h5 class="mt-2">Loading your Dashboard</h5>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-sheet>
</template>

<script>
	import {
		mapGetters,
		mapActions
	} from "vuex";

	import CountDownTimer from "@/components/CountDownTimer.vue";

	import api from "@/services/api-service";

	export default {
		name: "Callback",

		components: {
			CountDownTimer
		},

		computed: {
			...mapGetters("appshell", ["loading"]),
			...mapGetters("auth", ["user", "partner", "authenticated"])
		},

		data: () => ({
			error: null
		}),

		methods: {
			...mapActions("appshell", ["addActiveRequest", "removeActiveRequest"]),

			transferToPage() {
				//const last_route =
				//	localStorage.getItem("route_to") &&
				//	JSON.parse(localStorage.getItem("route_to"));

				//let params = (last_route && last_route.params) || {};
				//let query = (last_route && last_route.query) || {};
				//let path = (last_route && last_route.path) || "/dashboard";
				//let routingObject = {
				//	path: path,
				//	params: params,
				//	query: query
				//};
				this.$router.replace("/dashboard");
			},

			forcedLogin() {
				this.addActiveRequest();
				setTimeout(() => {
					this.$store.dispatch("auth/login", {
						force: true
					});
				}, 1000);
			},
			login() {
				this.$store.dispatch("auth/login", {
					silent: false
				});
			},

			async loadPartner() {
				try {
					this.addActiveRequest();

					const url = `partners/${this.user.entitykey}/`;
					const response = await api.get(url, {
						requestId: url
					});

					if (response && response.status == 200 && response.data) {
						const partner = response.data;
						this.$store.commit("auth/setPartner", partner);
						this.transferToPage();
					}
				} catch (error) {
					console.log("Callback.loadPartner.error", error.response);
					this.error = error.message;
				} finally {
					this.removeActiveRequest();
				}
			}

		},

		async created() {
			try {
				// dispatch auth:
				await this.$store.dispatch("auth/handleRedirectCallback");
				await this.loadPartner();
			} catch (error) {
				console.log("Callback.created.auth/handleRedirectCallback.error", error);
				this.error = error.message;
			}
		}
	};
</script>